export default "__VITE_ASSET__DUP2xNyD__"